import { render, staticRenderFns } from "./CustomerPromosForm.vue?vue&type=template&id=380a8950"
import script from "./CustomerPromosForm.vue?vue&type=script&lang=js"
export * from "./CustomerPromosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports